<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Add Mobile Money Account</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form method="post" :action="url" @submitted="$emit('added', $event)">
          <v-row no-gutters>
            <v-col cols="6" class="px-1">
              <custom-input name="title" label="Title" />
            </v-col>
            <v-col cols="6" class="px-1">
              <custom-input name="owner_name" label="Owner Name" />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-select
                :items="countries"
                name="country"
                item-text="name"
                item-value="name"
                @changed="updateMobileMoneyOperators"
                label="Country"
              />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-combobox
                ref="operator"
                name="operator"
                outlined
                item-value="name"
                item-text="name"
                :items="operators"
                label="Operator"
              >
              </custom-combobox>
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-input
                name="phone_number"
                :label="
                  'Phone Number' +
                  (selectedCountry ? ' ' + '(+' + selectedCountry.dial_code + ')' : '')
                "
              />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-button block color="primary">
                Add Mobile Money Accounts
              </custom-button>
            </v-col>
          </v-row>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    owner: { default: () => {}, type: Object },
    user: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      countries: [],
      operators: [],
      selectedCountry: null,
    };
  },

  computed: {
    url() {
      if (this.owner == null) {
        return `/api/v1/userMMAccounts`;
      }
      return `/api/v1/userMMAccounts/${this.owner.id}`;
    },
  },
  created() {
    this.$http.get("/api/v1/get-countries").then((response) => (this.countries = response));
  },
  methods: {
    pluck: (property) => (element) => element[property],
    async updateMobileMoneyOperators(name) {
      let country = await this.$http.get(`api/v1/get-countries?name=${name}`);
      this.selectedCountry = country[0];
      await this.$http.get(`/api/v1/cashout/${country[0].code}`).then((response) => {
        let cash_out_method = response.filter((_res) => {
          return (
            _res.cash_out_method.name == "Mobile Money Internal" ||
            _res.cash_out_method.name == "Mobile Money by Hub2"
          );
          // return (
          //   _res.cash_out_method.payment_provider.name == "Hub2" ||
          //   _res.cash_out_method.payment_provider.name == "danapay"
          // );
        })[0];

        this.operators =
          cash_out_method != undefined ? cash_out_method.providers.map(this.pluck("name")) : [];
      });
    },
  },
};
</script>
